import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AdminStatsState } from "../../models/mp-admin/admin-stats-state";

const initialState: AdminStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.stats.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.stats.getFail, (state, action) => ({ ...state, ..._.omit(action, "type") }))
);

export function adminStatsReducer(state: AdminStatsState, action: Action): AdminStatsState {
	return reducer(state, action);
}
